"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function Reset(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M4 12c0 4.431 3.569 8 8 8a7.94 7.94 0 0 0 5.646-2.354L16 16h5v5l-1.941-1.941C17.248 20.868 14.756 22 12 22 6.488 22 2 17.512 2 12zm8.936-5c.128 0 .237.097.252.225l.117 1.011a3.96 3.96 0 0 1 1.3.752l.938-.406a.25.25 0 0 1 .318.107l.938 1.622a.254.254 0 0 1-.069.33l-.808.599c.048.246.078.5.078.76s-.029.512-.076.758l.806.599a.253.253 0 0 1 .069.33l-.938 1.622a.25.25 0 0 1-.318.105l-.936-.402a3.962 3.962 0 0 1-1.302.752l-.117 1.011a.255.255 0 0 1-.252.225h-1.872a.253.253 0 0 1-.251-.225l-.118-1.011a3.96 3.96 0 0 1-1.3-.752l-.938.406a.25.25 0 0 1-.318-.107l-.938-1.622a.254.254 0 0 1 .069-.33l.808-.599A3.965 3.965 0 0 1 8 12c0-.26.03-.514.078-.76l-.808-.599a.253.253 0 0 1-.069-.33l.938-1.622a.25.25 0 0 1 .318-.105l.938.404a3.96 3.96 0 0 1 1.3-.752l.118-1.011A.253.253 0 0 1 11.064 7zM12 10a2 2 0 1 0-.001 3.999A2 2 0 0 0 12 10zm0-8c5.512 0 10 4.488 10 10h-2c0-4.431-3.569-8-8-8a7.94 7.94 0 0 0-5.646 2.354L8 8H3V3l1.941 1.941C6.752 3.132 9.244 2 12 2z", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = Reset;
